import { FormattedMessage } from 'react-intl';

import { SBHorizontal } from '#src/atoms/layout/flex/index.tsx';
import { PoweredByRotowire } from '#src/components/rotowire/PoweredByRotowire/index.tsx';

export const NewsTitleContent = () => {
  return (
    <SBHorizontal>
      <span>
        <FormattedMessage defaultMessage="News" />
      </span>
      <PoweredByRotowire />
    </SBHorizontal>
  );
};
